<template>
  <div :style="style" id="ace-editor"></div>
  <!-- TODO: use unqiue ID so that having multiple editors isn't a problem -->
</template>

<script>
  import { Events } from '../events'
  import * as ace from 'brace'

  import 'brace/theme/tomorrow_night'
  import 'brace/mode/python'
  import 'brace/ext/language_tools'
  import 'brace/ext/statusbar'
  import 'brace/ext/error_marker'
  import { log } from '../util/log'

  export default {
    name: 'TextEditor',
    data: () => ({
      editor: null,
      inputVal: '',
    }),
    props: {
      value: {
        default: ''
      },
      width: {
        type: [String, Number],
        default: '100%'
      },
      height: {
        type: [String, Number],
        default: '100%'
      }
    },
    created() {
      Events.$on('addError', (payload) => {
        log("Marking errors")

        this.addError(
          payload.msg,
          payload.line_start,
          payload.line_end,
          payload.col_start,
          payload.col_end
        )
      })
    },
    mounted() {
      this.editor = ace.edit('ace-editor')
      this.editor.getSession().setMode('ace/mode/python')
      this.editor.setTheme('ace/theme/tomorrow_night')
      this.editor.setValue(this.value, -1)

      this.editor.on('change', () => {
        this.inputVal = this.editor.getValue()
      })
    },
    watch: {
      inputVal(val) {
        this.$emit('input', val)
      }
    },
    methods: {
      addError(msg, startLine, endLine, startColumn, endColumn) {
        this.$nextTick(() => {
          // TODO: mark/underline errors
          this.editor.getSession().setAnnotations([
            {
              row: startLine,
              column: startColumn,
              text: msg,
              type: "error"
            }
          ])
        })
      }
    },
    beforeDestroy() {
      // TODO: this is monaco code. replace with equivalent for ace
      if (this.editor) {
        this.editor.container.remove()
        this.editor.destroy()
      }
    },
    computed: {
      style() {
        return {
          width: !/^\d+$/.test(this.width) ? this.width : `${this.width}px`,
          height: !/^\d+$/.test(this.height) ? this.width : `${this.height}px`
        }
      }
    }
  }
</script>
